import type { Household } from "@/types/household";

/** Match the existing /households/attention default contract using list data. */
export function selectHouseholdsNeedingAttention(households: readonly Household[]): Household[] {
  return households
    .filter((household) => household.health_score !== null && household.health_score < 80)
    .sort((first, second) => first.health_score! - second.health_score!)
    .slice(0, 5);
}
